import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config'

export default {
  name: 'stockistshipmenthub',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect,
    Validator
  },
  data() {
    return {
      gethublist:[],
      hubname:'',
      show:false,
      newhublist:[],
      awbnumber:[],
      myStr:'',
      isLoading:false,
      localuserid:'',
      successShipment: 0,
      failedShipments: [],
      localusermailid:''
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    var userToken = window.localStorage.getItem('userToken');
    this.myStr = userToken.replace(/"/g,'');
    this.getzonehubs();
  },
  methods: {
    async getzonehubs() {
      this.isLoading = true;
      this.show = true;
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'external/getHubdropdownlist',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        this.show = false;
        result.data.data.forEach((hub) => {
          this.newhublist.push({
            id: hub.HubID,
            label: hub.HubName
          })
        })
      },
      error => {
        this.show = false;
        console.error(error)
      })
      this.isLoading = false;
    },

    Submitfunction() {
      try{
        this.failedShipments = [];
        this.successShipment = 0;

        this.$validator.validateAll().then((result) => {
          this.isLoading = true;
          if(!this.awbnumber || !this.hubname){
            this.$alertify.error("Provide required data")
          }
          if(this.awbnumber.length>0 && this.hubname){
            let awb = this.awbnumber
            awb=awb.replace(/[ ,]+/g, ",")
            awb=awb.replace(/\t/g,",")
            awb=awb.replace(/,\s*$/, "")
            awb=awb.replace(/,,/g, ",");
            awb=awb.split(',');

            let input =  {
              "ShippingId" : awb.slice(0,10) ,
              "HubId": this.hubname.id,
              "LastModifiedBy": this.localusermailid
            };

            if(awb.length>10){
            this.failedShipments = awb.slice(10,awb.length)
            }

            axios({
              method: 'POST',
              url: apiUrl.api_url + 'StockistUpdateHub',
              data: input,
              headers: {
                'Authorization': 'Bearer ' + this.myStr
              }
            }).then(result => {
              result.data.forEach((item, i) => {
                if(item.shipmentupdate.code === 100 && item.stokist.code === 100){
                  this.successShipment += 1;
                }else{
                  this.failedShipments.push(item.ShippingId);
                }
              });
              this.isLoading = false;
            })
          }else{
            this.isLoading=false;
          }
        }).catch((err) => {
          console.log('=====Error====\n', err)
          this.isLoading = false;
        });
      }catch(err){
        console.error("=====Error====\n"+err);
        this.isLoading = false;
      }
    },
    resetForm(){
      this.$validator.reset();
      this.failedShipments = [];
      this.successShipment = 0;
      this.awbnumber = [];
      this.hubname='';
    }
  }
};


Validator.extend('Max_AWBs', {
  getMessage: field => "Maximum 10 AWBs allowed",
  validate: value => {
    var awbnumberVal = $("#AWB").val();
    let awbnumberarray = awbnumberVal.split(/[,]+/);
    if (awbnumberarray.length > 10) {
        return false;
      }
     else {
      return true;
    }
  }
});



// WEBPACK FOOTER //
// ./src/views/components/StockistShipmentHub/StockistShipmentHub.component.js